import React, {cloneElement} from 'react';
import {Pressable, Text, TextInput, View, Platform} from 'react-native';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import makeStyles from './styles';
import CommonStyles from '../../../utils/CommonStyles';

export default function Input(props) {
  const {
    style = {},
    inputStyle = {},
    containerStyle = {},
    hasError,
    errorText = '',
    secureTextEntry,
    rightIcon,
    onPressRightIcon,
    inputTitle = '',
    topMargin = 0,
    leftText,
    rightText,
    renderTitle,
    testID = '',
  } = props;
  // Themed DEFAULT placeholder color (legacy grey2 → textMuted; identical in
  // light). {...props} spreads after it, so a caller's placeholderTextColor
  // still wins.
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View
      testID={tID('Input-View-Main')}
      style={[{marginTop: topMargin}, containerStyle]}
    >
      {renderTitle ? (
        <Text testID={tID('Input-Text-CustomTitle')} style={styles.mb8}>
          {renderTitle}
        </Text>
      ) : (
        inputTitle.length > 0 &&
        !renderTitle && (
          <Text testID={tID('Input-Text-Title')} style={styles.inputTitleStyle}>
            {inputTitle}
          </Text>
        )
      )}
      <View style={[styles.container(hasError), style]}>
        {leftText !== undefined && leftText.length > 0 && (
          <Text testID={tID('Input-Text-Left')} style={styles.leftText}>
            {leftText}
          </Text>
        )}
        <TextInput
          placeholderTextColor={colors.textMuted}
          {...props}
          style={[
            styles.inputContainer(hasError),
            inputStyle,
            Platform.OS === 'web' && styles.zeroOutlineWidth,
          ]}
          secureTextEntry={secureTextEntry}
          testID={testID}
        />
        {rightIcon ? (
          <Pressable
            testID={tID('Input-Pressable-Right')}
            accessibilityRole="button"
            accessibilityLabel={
              secureTextEntry ? 'Show password' : 'Hide password'
            }
            hitSlop={{top: 12, bottom: 12, left: 12, right: 12}}
            onPress={onPressRightIcon}
          >
            {cloneElement(rightIcon, {
              testID: tID('Input-Image-Right'),
              style: CommonStyles.ml_16,
              width: 20,
              height: 20,
            })}
          </Pressable>
        ) : null}
        {rightText && (
          <Text testID={tID('Input-Text-Right')} style={styles.rightText}>
            {rightText}
          </Text>
        )}
      </View>
      {hasError && errorText.length > 0 && (
        <Text testID={tID('Input-Text-Error')} style={styles.errorText}>
          {errorText}
        </Text>
      )}
    </View>
  );
}
